import { render, staticRenderFns } from "./base-modal.vue?vue&type=template&id=98b8a168&scoped=true&"
import script from "./base-modal.vue?vue&type=script&lang=js&"
export * from "./base-modal.vue?vue&type=script&lang=js&"
import style0 from "./base-modal.vue?vue&type=style&index=0&id=98b8a168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b8a168",
  null
  
)

export default component.exports